// extracted by mini-css-extract-plugin
export default {"btnpwd":"_32eb9e1619"};